import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from '@/App';
import { BrowserRouter } from "react-router-dom";

import '@/assets/css/index.less';
import './index.less';
import ErrorBoundary from './components/ErrorBoundary';
// 导入即初始化 ARMS RUM 监控(endpoint 未配置时整体停用,零影响);详见 src/utils/monitor.js
import '@/utils/monitor';

import 'antd-mobile/es/global'
try {

  const rootElement = document.getElementById('root');

  const renderApp = () => {
    ReactDOM.render(
      <React.StrictMode>
          <ErrorBoundary>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
          </ErrorBoundary>
      </React.StrictMode>,
      document.getElementById('root'),
    );
  };
  renderApp();
} catch (e) {
  console.log('e');
}
